
























import Vue from 'vue';
import { Component, InjectReactive, Prop } from 'vue-property-decorator';
import { debounce } from 'debounce';
import { defer } from 'frontend/utils/timing';
import { getTestId } from 'frontend/utils/test-id';
import { Optional } from 'frontend/types';

@Component({})
export default class SearchInput extends Vue {
  @InjectReactive() private readonly searchQuery!: string;
  @Prop(Boolean) private inHeader!: boolean;
  @Prop(String) private readonly testIdPrefix: Optional<string>;
  private value = '';

  private get placeholderText(): string {
    if (this.inHeader) {
      return '';
    }
    return 'Search courses and topics';
  }

  private get testId(): string {
    return getTestId(this.testIdPrefix, 'search_input');
  }

  public focus(): SearchInput {
    (this.$refs.input as HTMLInputElement).focus();
    return this;
  }

  public blur(): SearchInput {
    (this.$refs.input as HTMLInputElement).blur();
    return this;
  }

  public setValue(value: string): SearchInput {
    this.value = value;
    return this;
  }

  private get trimmedValue(): string {
    return this.value.trim();
  }

  private get debouncedUpdateSearchQuery(): () => void {
    return debounce(this.updateSearchQuery, 0); // no debounce for now actually
  }

  private updateSearchQuery(): SearchInput {
    defer(() => this.$emit('update-search-query', this.trimmedValue));
    return this;
  }

  private update(): void {
    if (this.trimmedValue.length > 0) {
      this.debouncedUpdateSearchQuery();
    } else {
      this.updateSearchQuery();
    }
  }

  private clear(): void {
    this.setValue('').focus().update();
  }

  private mounted() {
    this.value = this.searchQuery;
  }
}
